import ConfirmationContextProvider, { ConfirmationContext } from './ConfirmationContext';

export { ConfirmationContext };
export default ConfirmationContextProvider;